<template>
  <CSidebar
    fixed
    class="sidebar"
    :minimize="minimize"
    :show="show"
    @update:show="(value) => $store.commit('set', ['sidebarShow', value])"
  >
    <CSidebarBrand class="d-md-down-none" to="/">
      <img src="/img/custimoo-logo.svg" height="25" alt="" />
    </CSidebarBrand>
    <CRenderFunction flat :content-to-render="arr" />
    <CSidebarMinimizer
      class="d-md-down-none"
      @click.native="$store.commit('set', ['sidebarMinimize', !minimize])"
    />
  </CSidebar>
</template>

<script>
import navMixin from "../mixins/navMixin";
export default {
  name: "TheSidebar",

  computed: {
    show() {
      return this.$store.state.sidebarShow;
    },
    minimize() {
      return this.$store.state.sidebarMinimize;
    },
  },
  async created() {
    this.$store.commit("set", ["showLoader", true]);
    await this.$store.dispatch("getnavigation");
    this.$root.$refs.TheSidebar = this;
    this.arr = this.$store.getters.getnavigations;
    this.$store.commit("set", ["showLoader", false]);
  },
  mixins: [navMixin],
  data() {
    return {
      arr: [],
    };
  },
  watch: {
    "$store.state.navigation": {
      immediate: true,
      handler() {
        this.arr = this.$store.getters.getnavigations;
      },
    },
  },
};
</script>

<style lang="scss" scoped></style>
